module.exports = __webpack_public_path__ + "img/type-h3.a1f3b4d6.svg";